import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/media";

interface MediaCardProps {
  item: MediaItem;
  rank?: number;
}

export default function MediaCard({ item, rank }: MediaCardProps) {
  const meta = `${item.genres.slice(0, 2).join(" · ")} · ${item.year}`;

  return (
    <Link to={`/detail/${item.id}`} className="group block cursor-pointer">
      <div className="relative w-full aspect-[2/3] overflow-hidden rounded-lg bg-secondary-200">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} 海报`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 top-0 h-16 bg-gradient-to-b from-foreground-950/50 to-transparent"></div>
        <span className="absolute top-2 right-2 inline-flex items-center gap-1 rounded-md bg-foreground-950/70 px-1.5 py-0.5 text-xs font-semibold text-accent-400 backdrop-blur">
          <i className="ri-star-fill text-[10px]"></i>
          {item.rating.toFixed(1)}
        </span>
        {typeof rank === "number" ? (
          <span className="absolute top-0 left-0 w-9 h-9 rounded-br-xl rounded-tl-lg bg-accent-500 text-background-50 font-heading text-lg font-bold flex items-center justify-center">
            {rank}
          </span>
        ) : null}
        {item.kind === "tv" && item.status ? (
          <span
            className={`absolute bottom-2 left-2 rounded-md px-1.5 py-0.5 text-[11px] font-medium backdrop-blur ${
              item.status === "连载"
                ? "bg-accent-500/90 text-background-50"
                : "bg-foreground-950/70 text-background-50"
            }`}
          >
            {item.status}
          </span>
        ) : null}
        <div className="absolute inset-0 flex items-center justify-center bg-foreground-950/40 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="w-11 h-11 rounded-full bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-information-line text-2xl"></i>
          </span>
        </div>
      </div>
      <h3 className="mt-2 text-sm font-medium text-foreground-900 line-clamp-1 transition-colors group-hover:text-primary-600">
        {item.title}
      </h3>
      <p className="mt-0.5 text-xs text-foreground-500">{meta}</p>
    </Link>
  );
}